import { render, staticRenderFns } from "./SimpleListLi.vue?vue&type=template&id=0f11b3be&scoped=true&lang=pug&"
var script = {}
import style0 from "./SimpleListLi.vue?vue&type=style&index=0&id=0f11b3be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f11b3be",
  null
  
)

export default component.exports